/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activate_Confirm_TitleInputs */

const en_activate_confirm_title = /** @type {(inputs: Activate_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activate Subscription?`)
};

const fr_activate_confirm_title = /** @type {(inputs: Activate_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer l'abonnement ?`)
};

const de_activate_confirm_title = /** @type {(inputs: Activate_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement aktivieren?`)
};

const it_activate_confirm_title = /** @type {(inputs: Activate_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attivare l'abbonamento?`)
};

const ru_activate_confirm_title = /** @type {(inputs: Activate_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активировать подписку?`)
};

const es_activate_confirm_title = /** @type {(inputs: Activate_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Activar suscripción?`)
};

const zh_cn2_activate_confirm_title = /** @type {(inputs: Activate_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`激活订阅？`)
};

const ja_activate_confirm_title = /** @type {(inputs: Activate_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプションをアクティブ化しますか?`)
};

const hi_activate_confirm_title = /** @type {(inputs: Activate_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सदस्यता सक्रिय करें?`)
};

const pt_pt2_activate_confirm_title = /** @type {(inputs: Activate_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativar assinatura?`)
};

/**
* | output |
* | --- |
* | "Activate Subscription?" |
*
* @param {Activate_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const activate_confirm_title = /** @type {((inputs?: Activate_Confirm_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activate_Confirm_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_activate_confirm_title(inputs)
	if (locale === "de") return de_activate_confirm_title(inputs)
	if (locale === "it") return it_activate_confirm_title(inputs)
	if (locale === "ru") return ru_activate_confirm_title(inputs)
	if (locale === "es") return es_activate_confirm_title(inputs)
	if (locale === "zh-CN") return zh_cn2_activate_confirm_title(inputs)
	if (locale === "ja") return ja_activate_confirm_title(inputs)
	if (locale === "hi") return hi_activate_confirm_title(inputs)
	if (locale === "pt-PT") return pt_pt2_activate_confirm_title(inputs)
	return en_activate_confirm_title(inputs)
});